import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import {
  ComponentProps,
  ControlInput,
  ControlTemplateProps,
} from "../misc/controlInput";

export interface ControlCheckboxProps extends ControlTemplateProps {}

export const ControlCheckbox: React.FC<ControlCheckboxProps> = (props) => {
  const styles: IControlStyles = props?.controlStyles ?? useControlStyles();

  return (
    <ControlInput
      type="checkbox"
      {...ComponentProps(props)}
      style={{
        ...(styles.checkbox ?? styles.radio ?? styles.switch ?? styles.input),
        ...props.style,
      }}
    />
  );
};
